import Swiper from "swiper";
import 'swiper/swiper-bundle.css';
import { ProductCard } from "../common/product-card-class";
import { enableOnlyTable } from ".";

const state = {
  components: [],
  elements: {},
}

const cacheState = () => {
  const sections = Array.from(document.querySelectorAll('[data-section="hub-features-benefits"]'));
  state.components = sections.reduce((components, section) => {
    const currentComponent = {
      id: section.dataset.overlayId,
      bodySlider: { 
        el: section.querySelector('.hub-features__body'),
        navigation: section.querySelectorAll('.hub-features__navigation'),
        videos: section.querySelectorAll('.hub-features__body .hub-features__media-video'),
        slides: section.querySelectorAll('.hub-features__body .swiper-slide:not(.swiper-slide-duplicate)'),
      },
      footerSlider: {
        el: section.querySelector('.hub-features__footer'),
        inner: section.querySelector('.hub-features__footer-slider'),
        type: section.querySelector('.hub-features__footer').dataset.sliderType
      },
      scrollDownBtn: section.querySelector('[data-scroll-down]')
    }
    return [...components, currentComponent]
  },[])

  state.elements = {
    products: document.querySelectorAll('.product-item.product-grid-item')
  }
}

const initSwiper = () => {
  state.components.forEach(component => {
    component.bodySlider.swiper = new Swiper(component.bodySlider.el, {
      slidesPerView: 1,
      loopAdditionalSlides: 10,
      spaceBetween: 10,
      loop: true,
      on: {
        slideChange: (swiper) => {
          component.footerSlider.swiper?.slideTo((swiper.realIndex + 1) % component.bodySlider.slides.length);
          if (component.footerSlider.swiper?.el.dataset.sliderType !== 'features') return;

          component.footerSlider.swiper?.slides.forEach(slide => {
            if (slide.dataset.swiperSlideIndex == swiper.realIndex) {
              slide.classList.add("hidden-tablet")
            } else {
              slide.classList.remove("hidden-tablet")
            }
          })
        },
      }
    })
    if(component.footerSlider.type === "disabled") return;
    component.footerSlider.swiper = new Swiper(component.footerSlider.el, {
      slidesPerView: 2,
      initialSlide: component.footerSlider.el.dataset.sliderType === 'features' ? 1 : 0,
      loopAdditionalSlides: 10,
      spaceBetween: component.footerSlider.el.dataset.sliderType === 'features' ? 10 : 5,
      loop: true,
      allowTouchMove: false,
      breakpoints: {
        990: {
          slidesPerView: 6,
          spaceBetween: component.footerSlider.el.dataset.sliderType === 'features' ? 20 : 5,
        },
        769: {
          slidesPerView: 4.2,
        },
        450: {
          slidesPerView: 2.5,
        },
      },
      on: {
        afterInit: enableOnlyTable,
        resize: enableOnlyTable,
      }
    })
  })
}

const addEventListeners = () => {
  document.addEventListener('overlay:open', updateSwiperOnShow)

  state.components.forEach(component => {
    component.bodySlider.navigation.forEach(btn => {
      btn.addEventListener('click', onNavClick.bind(component))
    })

    component.scrollDownBtn.addEventListener('click', () => {
      component.footerSlider.el.scrollIntoView({behavior: "smooth"})
    })

    if (component.footerSlider.type !== "features") return;
    component.footerSlider.inner.addEventListener('click', onFeatureClicked.bind(component))
  })
}

function onFeatureClicked(e) {
  const clickedSlide = e.target.closest('.hub-features__footer-item');
  const targetIndex = clickedSlide?.dataset.swiperSlideIndex;
  if (!targetIndex) return;
  
  this.bodySlider.swiper.slideTo(+targetIndex);
  this.bodySlider.el.scrollIntoView({behavior: "smooth"})
}

function onNavClick (e) {
  const action = e.target.closest('button')?.dataset.action;
  this.bodySlider.swiper?.[action]();
}

const updateSwiperOnShow = (e) => {
  const componentsToUpdate = state.components.filter(component => component.id === e.detail.id);

  componentsToUpdate.forEach(component => {
    component.bodySlider.swiper.update();
    component.footerSlider.swiper?.update();
    component.bodySlider.videos.forEach(video => video.play())
  })
}

const initProducts = () => {
  state.elements.products.forEach(product => {
    new ProductCard(product);
  })
}

const init = () => {
  cacheState();
  initProducts();
  initSwiper();
  addEventListeners();
}

export default init;